(function () {
  'use strict';

  // Gallery thumb swap
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-fullsize-src');
        if (main && src) {
          main.setAttribute('src', src);
          var srcset = main.getAttribute('srcset');
          if (srcset) main.removeAttribute('srcset');
        }
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  // Quantity stepper
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var dec = wrap.querySelector('[data-qty-dec]');
      var inc = wrap.querySelector('[data-qty-inc]');
      if (!input) return;
      if (dec) dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (inc) inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // Variant picker
  function initVariantPicker() {
    var form = document.querySelector('[data-product-form]');
    var picker = document.querySelector('[data-variant-picker]');
    var dataEl = document.querySelector('[data-product-json]');
    if (!form || !picker || !dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('[data-variant-id-input]');
    var priceEl = document.querySelector('[data-price]');
    var atc = form.querySelector('[data-atc]');
    var S = window.productStrings || {};
    var express = document.querySelector('.pdp__express');
    var unavailableMsg = document.querySelector('[data-unavailable-msg]');
    var lowStockEl = document.querySelector('[data-low-stock]');
    var lowStockMap = {};
    var lowStockData = document.querySelector('[data-low-stock-map]');
    if (lowStockData) { try { lowStockMap = JSON.parse(lowStockData.textContent) || {}; } catch (e) {} }
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    var stickyPriceEl = document.querySelector('[data-sticky-price]');

    function readSelections() {
      var sel = [];
      picker.querySelectorAll('[data-option-position]').forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-option-position'), 10);
        if (group.tagName === 'SELECT') {
          sel[pos - 1] = group.value;
        } else {
          var checked = group.querySelector('[aria-checked="true"]');
          if (checked) sel[pos - 1] = checked.getAttribute('data-option-value') || checked.getAttribute('aria-label');
        }
      });
      return sel;
    }

    function findVariant(sel) {
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== undefined && v.options[j] !== sel[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      var fmt = window.moneyFormat || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{[^}]*\}\}/g, amount);
    }

    function swapVariantImage(v) {
      if (!v || !v.featured_image || !v.featured_image.src) return;
      var main = document.querySelector('[data-gallery-main] img');
      if (!main) return;
      var fresh = v.featured_image.src;
      // Strip ?v= cache-buster to match thumb URLs reliably.
      var freshKey = fresh.split('?')[0];
      // Compare the file base (everything before the trailing _NNNxNNN size suffix).
      function basename(u) {
        return u.split('?')[0].split('/').pop().replace(/_\d+x\d*\.(jpe?g|png|webp|gif)$/i, '.$1');
      }
      var targetBase = basename(fresh);
      var newSrc = null;
      // Prefer matching by data-image-id (numeric Shopify image ID) — most reliable.
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      var matchedThumb = null;
      thumbs.forEach(function (t) {
        if (matchedThumb) return;
        var tImageId = t.getAttribute('data-image-id');
        if (tImageId && String(v.featured_image.id) === tImageId) matchedThumb = t;
      });
      // Fallback: match by filename basename
      if (!matchedThumb) {
        thumbs.forEach(function (t) {
          if (matchedThumb) return;
          var tSrc = t.getAttribute('data-fullsize-src') || '';
          if (basename(tSrc) === targetBase) matchedThumb = t;
        });
      }
      if (matchedThumb) {
        newSrc = matchedThumb.getAttribute('data-fullsize-src');
      } else {
        // Variant image not in product media list — fall back to the variant's own src
        newSrc = fresh;
      }
      if (newSrc) {
        main.setAttribute('src', newSrc);
        if (main.hasAttribute('srcset')) main.removeAttribute('srcset');
        main.removeAttribute('sizes');
      }
      thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
      if (matchedThumb) matchedThumb.setAttribute('aria-current', 'true');
    }

    // 2026-09-25: grey out values that have no purchasable variant given the OTHER selected
    // options (Colour x Size), and keep the aria-label honest. Runs after every selection.
    // 2026-10-16: for each option value, given the OTHER selected options, decide whether a variant
    // exists at all ("unavailable": the combination was never made) or exists but is sold out.
    // Dawn/Horizon pattern: keep every value visible and clickable, mark it, and say which it is.
    function valueState(pos, val, sel) {
      var exists = false, avail = false;
      for (var k = 0; k < product.variants.length; k++) {
        var variant = product.variants[k];
        if (variant.options[pos - 1] !== val) continue;
        var ok = true;
        for (var i = 0; i < sel.length; i++) {
          if (i === pos - 1 || sel[i] === undefined || sel[i] === null) continue;
          if (variant.options[i] !== sel[i]) { ok = false; break; }
        }
        if (!ok) continue;
        exists = true;
        if (variant.available) { avail = true; break; }
      }
      return exists ? (avail ? 'ok' : 'soldout') : 'unavailable';
    }

    function refreshAvailability(sel) {
      if (!product || !product.variants) return;
      picker.querySelectorAll('[data-option-position]').forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-option-position'), 10);
        if (group.tagName === 'SELECT') {
          Array.prototype.forEach.call(group.options, function (opt) {
            if (!opt.hasAttribute('data-base')) opt.setAttribute('data-base', opt.textContent);
            var st = valueState(pos, opt.value, sel);
            var base = opt.getAttribute('data-base');
            opt.textContent = st === 'ok' ? base : base + ' (' + (st === 'soldout' ? (S.soldOutLower || 'sold out') : (S.unavailableLower || 'unavailable')) + ')';
          });
          return;
        }
        group.querySelectorAll('.swatch[data-option-value]').forEach(function (sw) {
          var val = sw.getAttribute('data-option-value');
          var st = valueState(pos, val, sel);
          sw.classList.toggle('swatch--soldout', st === 'soldout');
          sw.classList.toggle('swatch--unavailable', st === 'unavailable');
          if (st === 'unavailable') sw.setAttribute('aria-disabled', 'true'); else sw.removeAttribute('aria-disabled');
          var base = sw.getAttribute('title') || val;
          sw.setAttribute('aria-label', st === 'ok' ? base : base + ' (' + (st === 'soldout' ? (S.soldOutLower || 'sold out') : (S.unavailableLower || 'unavailable')) + ')');
        });
      });
    }

    function setHidden(el, hide) { if (el) { if (hide) el.setAttribute('hidden', ''); else el.removeAttribute('hidden'); } }

    function renderLowStock(v) {
      if (!lowStockEl) return;
      var n = v ? lowStockMap[String(v.id)] : null;
      if (!n) { lowStockEl.textContent = ''; lowStockEl.setAttribute('hidden', ''); return; }
      var txt = (S.lowStock || 'Only __COUNT__ left').replace('__COUNT__', n);
      if (v.options.length && v.title !== 'Default Title' && v.options[0]) txt += ' ' + (S.lowStockIn || 'in') + ' ' + v.options[0];
      lowStockEl.textContent = txt + '.';
      lowStockEl.removeAttribute('hidden');
    }

    // No variant matches what the shopper picked (e.g. Gold only comes in Large and they picked
    // Medium). Never fall back to the previous variant: clear the cart id, block every buy path,
    // hide the variant-specific details and say why. The selection itself stays as chosen.
    function setUnavailable(sel) {
      if (idInput) idInput.value = '';
      if (atc) { atc.setAttribute('disabled', ''); atc.textContent = S.unavailable || 'Unavailable'; }
      if (stickyBtn) { stickyBtn.setAttribute('disabled', ''); stickyBtn.textContent = S.unavailable || 'Unavailable'; }
      setHidden(express, true);
      setHidden(priceEl, true);
      setHidden(stickyPriceEl, true);
      setHidden(document.querySelector('[data-item-code]'), true);
      setHidden(document.querySelector('[data-stock]'), true);
      renderLowStock(null);
      if (unavailableMsg) {
        var picked = sel.filter(function (x) { return x !== undefined && x !== null; });
        var msg = picked.length >= 2
          ? (S.unavailableCombo || '{first} doesn\'t come in {rest}. Choose another option.').replace('{first}', picked[0]).replace('{rest}', picked.slice(1).join(' / '))
          : (S.unavailableGeneric || 'This option isn\'t available. Choose another option.');
        unavailableMsg.textContent = msg;
        unavailableMsg.removeAttribute('hidden');
      }
    }

    function update() {
      var sel = readSelections();
      var v = findVariant(sel);
      refreshAvailability(sel);
      if (!v) { setUnavailable(sel); return; }
      if (idInput) idInput.value = v.id;
      setHidden(express, false);
      setHidden(priceEl, false);
      setHidden(stickyPriceEl, false);
      setHidden(document.querySelector('[data-stock]'), false);
      if (unavailableMsg) { unavailableMsg.textContent = ''; unavailableMsg.setAttribute('hidden', ''); }
      if (stickyBtn) {
        if (v.available) { stickyBtn.removeAttribute('disabled'); stickyBtn.textContent = (window.cartStrings && window.cartStrings.addToCart) || 'Add to cart'; }
        else { stickyBtn.setAttribute('disabled', ''); stickyBtn.textContent = S.soldOut || 'Sold out'; }
      }
      renderLowStock(v);
      var _icv = document.querySelector('[data-item-code-value]');
      var _icw = document.querySelector('[data-item-code]');
      if (_icv) _icv.textContent = v.sku || '';
      if (_icw) { if (v.sku) { _icw.removeAttribute('hidden'); } else { _icw.setAttribute('hidden', ''); } }
      if (priceEl) priceEl.innerHTML = '<span class="price"><span class="price__current">' + formatMoney(v.price) + '</span></span>';
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = '<span class="price"><span class="price__current">' + formatMoney(v.price) + '</span></span>';
      var stockEl = document.querySelector('[data-stock]');
      if (stockEl) {
        stockEl.setAttribute('data-state', v.available ? 'in' : 'out');
        stockEl.textContent = v.available
          ? ((window.productStrings && window.productStrings.inStock) || 'In stock')
          : ((window.productStrings && window.productStrings.soldOut) || 'Sold out');
      }
      if (atc) {
        if (v.available) {
          atc.removeAttribute('disabled');
          atc.innerHTML = ((window.cartStrings && window.cartStrings.addToCart) || 'Add to cart') + '<span class="pdp__atc-price"> &middot; <span data-atc-price>' + formatMoney(v.price) + '</span></span>';
        } else {
          atc.setAttribute('disabled', '');
          atc.textContent = S.soldOut || 'Sold out';
        }
      }
      swapVariantImage(v);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    picker.querySelectorAll('select[data-option-position]').forEach(function (s) {
      s.addEventListener('change', update);
    });
    // Show the chosen value name next to a color option's label ("COLOR: Clear"); the label span is
    // rendered by main-product.liquid only for color options, so this is a no-op elsewhere.
    function syncSelectedLabel(group, value) {
      var pos = group.getAttribute('data-option-position');
      if (!pos) return;
      var lbl = picker.querySelector('[data-selected-for="' + pos + '"]');
      if (lbl) lbl.textContent = value;
    }

    picker.querySelectorAll('.swatches').forEach(function (group) {
      var swatches = group.querySelectorAll('.swatch[role="radio"][data-option-value]');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.setAttribute('aria-checked', 'false'); s.classList.remove('is-selected'); });
          sw.setAttribute('aria-checked', 'true');
          sw.classList.add('is-selected');
          syncSelectedLabel(group, sw.getAttribute('data-option-value') || sw.getAttribute('aria-label') || '');
          update();
        });
      });
    });
    refreshAvailability(readSelections());
  }

  // Sticky mobile ATC
  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var form = document.querySelector('[data-product-form]');
    if (!sticky || !form) return;
    var atc = form.querySelector('[data-atc]');
    var stickyBtn = sticky.querySelector('[data-sticky-atc-btn]');
    if (!atc) return;
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (atc.disabled) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) sticky.setAttribute('hidden', '');
        else sticky.removeAttribute('hidden');
      });
    }, { threshold: 0 });
    io.observe(atc);
  }

  // Recently viewed
  var STORAGE_KEY = 'crafts.recently_viewed';
  var MAX_ITEMS = 8;

  function readRecentlyViewed() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
  }

  function pushRecentlyViewed() {
    var cur = document.querySelector('[data-recently-viewed-current]');
    if (!cur) return;
    var data;
    try { data = JSON.parse(cur.textContent); } catch (e) { return; }
    if (!data || !data.handle) return;
    var list = readRecentlyViewed().filter(function (i) { return i.handle !== data.handle; });
    list.unshift(data);
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function renderRecentlyViewed() {
    var container = document.querySelector('[data-recently-viewed]');
    var list = container && container.querySelector('[data-recently-viewed-list]');
    if (!container || !list) return;
    var cur = document.querySelector('[data-recently-viewed-current]');
    var currentHandle = '';
    if (cur) { try { currentHandle = (JSON.parse(cur.textContent) || {}).handle || ''; } catch (e) {} }
    var items = readRecentlyViewed().filter(function (i) { return i.handle !== currentHandle; });
    if (!items.length) return;
    list.innerHTML = items.map(function (i) {
      return '<a class="card" href="' + i.url + '">' +
        '<div class="card__media"><img src="' + i.image + '" alt="' + (i.title || '').replace(/"/g, '&quot;') + '" width="400" height="400" loading="lazy" decoding="async"></div>' +
        '<p class="card__title">' + (i.title || '') + '</p>' +
        '<p class="card__price">' + (i.price || '') + '</p>' +
        '</a>';
    }).join('');
    container.removeAttribute('hidden');
  }

  function expandSwatches(group) {
    if (!group) return;
    group.classList.add('is-expanded');
    group.classList.remove('swatches--collapsed');
    group.querySelectorAll('.swatch--hidden').forEach(function (sw) {
      sw.classList.remove('swatch--hidden');
      sw.removeAttribute('hidden');
    });
  }

  function initExpandableSwatches() {
    document.querySelectorAll('[data-swatches-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.swatches');
        expandSwatches(group);
        var first = group && group.querySelector('.swatch[hidden], .swatch:nth-child(25)');
        if (first && first.focus) first.focus();
      });
    });
    // Type-to-filter for very large colour ranges (40+): matches on the colour name,
    // expands the grid while a filter is active, and announces the match count.
    document.querySelectorAll('[data-swatch-filter]').forEach(function (input) {
      var pos = input.getAttribute('data-swatch-filter');
      var group = document.querySelector('.swatches[data-option-position="' + pos + '"]');
      if (!group) return;
      var live = document.createElement('span');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      input.parentNode.appendChild(live);
      var swatches = group.querySelectorAll('.swatch:not(.swatch--more)');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        if (q) expandSwatches(group);
        var n = 0;
        swatches.forEach(function (sw) {
          var name = (sw.getAttribute('data-option-value') || '').toLowerCase();
          var hit = !q || name.indexOf(q) !== -1;
          sw.classList.toggle('swatch--filtered', !hit);
          if (hit) n++;
        });
        group.classList.toggle('swatches--filtering', !!q);
        live.textContent = q ? n + ' colors match' : '';
      });
    });
  }

  function init() {
    initGallery();
    initQty();
    initVariantPicker();
    initStickyAtc();
    initExpandableSwatches();
    pushRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
